export const news = {
  hero: {
    title: 'News & Stories',
    subtitle: 'Stay updated with our latest field reports, success stories, and announcements from the ground in the Democratic Republic of Congo',
  },
  featured: {
    badge: 'Featured Story',
    fieldReporter: 'Field Reporter',
    readFullStory: 'Read Full Story',
  },
  categories: {
    all: 'All',
    fieldUpdates: 'Field Updates',
    successStories: 'Success Stories',
    announcements: 'Announcements',
  },
  card: {
    readMore: 'Read More',
  },
  empty: {
    message: 'No articles found in this category',
  },
};
